// components/common/PageHero/index.tsx
// Hero section dùng chung cho nhiều trang

import Breadcrumb from '../../ui/Breadcrumb'
import type { BreadcrumbItem } from '../../ui/Breadcrumb'

interface PageHeroStat {
  number: string
  label: string
}

interface PageHeroProps {
  tag?: string
  title: string
  titleHighlight?: string // Từ được tô màu gold trong title
  description?: string
  breadcrumbs?: BreadcrumbItem[]
  stats?: PageHeroStat[]
  className?: string
}

const PageHero = ({
  tag,
  title,
  titleHighlight,
  description,
  breadcrumbs,
  stats,
  className = '',
}: PageHeroProps) => {
  // Nếu có titleHighlight, thay thế trong title bằng span màu gold
  const renderTitle = () => {
    if (!titleHighlight || !title.includes(titleHighlight)) {
      return title
    }
    const parts = title.split(titleHighlight)
    return (
      <>
        {parts[0]}
        <span>{titleHighlight}</span>
        {parts[1]}
      </>
    )
  }

  return (
    <section className={`page-hero ${className}`}>
      <div className="container">
        {/* Breadcrumb */}
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumb items={breadcrumbs} dark />
        )}

        {/* Tag */}
        {tag && (
          <div className="page-hero__tag">
            <i className="fas fa-home" />
            {tag}
          </div>
        )}

        {/* Title */}
        <h1 className="page-hero__title">{renderTitle()}</h1>

        {/* Description */}
        {description && (
          <p className="page-hero__description">{description}</p>
        )}

        {/* Stats */}
        {stats && stats.length > 0 && (
          <div className="page-hero__stats">
            {stats.map((stat, i) => (
              <div key={i} className="page-hero__stat-item">
                <span className="page-hero__stat-number">{stat.number}</span>
                <span className="page-hero__stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

export default PageHero
